<template>
  <div
    id="main_container"
    class="main_container"
  >
    <router-view></router-view>
  </div>
</template>

<script setup></script>

<style scoped>
.main_container {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  background-color: var(--main-bg);
  overflow: auto;
}

@media (max-width: 768px) {
  .main_container {
    padding: 0 16px;
  }
}
</style>
